import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
    PhysicianList: {},
    PhysicianListTop: {
        width: '100%',
        marginBottom: '3rem',
    },
}))
